import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminService {
  clientId = localStorage.getItem('selectedClientId');


  constructor(private http: HttpClient) { }

    //  *---------------Super Admin Client-----------------*
    getClientList(body, is_export: boolean = false) {
      if(is_export){
        return this.http.post(environment.baseApiUrl + `user/v1/client/list`, body, { observe: 'response', responseType: 'blob' });
      }else{
      return this.http.post<any>(environment.baseApiUrl + `user/v1/client/list`, body);
      }
    }
    postClient(body: {}) {
      return this.http.post(environment.baseApiUrl + 'user/v1/client', body);
    }
    deleteClient(id) {
      return this.http.delete(environment.baseApiUrl + `user/v1/client/${id}`);
    }
    updateClient(body: {}, id) {
      return this.http.put(environment.baseApiUrl + `user/v1/client/${id}`, body);
    }

    getCountryList(body, is_export: boolean = false) {
      if(is_export){
      return this.http.post(environment.baseApiUrl + `common/v1/country/list`, body, { observe: 'response', responseType: 'blob' });
      }else{
        return this.http.post<any>(environment.baseApiUrl + `common/v1/country/list`, body);
      }
    }
    getStateList(country_name) {
      return this.http.get(environment.baseApiUrl + `common/v1/states/by-country/${country_name}`);
    }
    getCityList(country_name,state_name) {
      return this.http.get(environment.baseApiUrl + `common/v1/cities/by-country/${country_name}/by-state/${state_name}`);
    }

    // AdminClient Feature
    postClientFeature(body: {}) {
      return this.http.post(environment.baseApiUrl + 'user/v1/client/feature', body);
    }

    updateClientFeature(body: {}, id) {
      return this.http.put(environment.baseApiUrl + `user/v1/client/feature/${id}`, body);
    }

    deleteClientFeature(id) {
      return this.http.delete(environment.baseApiUrl + `user/v1/client/feature/${id}`);
    }

    getClientFeatureList(body:{}) {
      return this.http.post(environment.baseApiUrl + `user/v1/client/feature/list`, body);
    }
}
